import { Controller } from "remult";

@Controller("group-user-methods")
export class GroupUserMethods {}
